module.exports = __webpack_public_path__ + "img/ic_design_item2.d9897bbd.png";